module.exports = __webpack_public_path__ + "img/分享.jpg";